// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2066":"8ed7486c","6256":"3965f91f"}[chunkId] + ".chunk.css";
};